import {
  getFilePresignedUrl,
  updateFile,
  createFile,
  UploadUrl,
} from "~/apis/file";

import CryptoJS from "crypto-js";
import {
  UploadRawFile,
  UploadProps,
  UploadRequestOptions,
} from "element-plus/es/components/upload/src/upload";
import axios from "axios";

import { useNuxtApp } from "nuxt/app";

/**
 * 获得上传 URL
 */
export const getUploadUrl = (): string => {
  return UploadUrl;
};

export const useUpload = () => {
  // 后端上传地址
  const uploadUrl = getUploadUrl();
  // 是否使用前端直连上传
  const isClientUpload =
    UPLOAD_TYPE.CLIENT === import.meta.env.VITE_UPLOAD_TYPE;
  // 重写ElUpload上传方法
  const httpRequest = async (options: UploadRequestOptions) => {
    // 模式一：前端上传
    if (isClientUpload) {
      try {
        // 1.1 生成文件名称
        const fileName = await generateFileName(options.file);
        // 1.2 获取文件预签名地址
        const presignedInfo = await getFilePresignedUrl(fileName);
        if (!presignedInfo) {
          // options.onError &&
          //   options.onError({
          //     msg: "No Support S3",
          //     originFileName: options.file.name,
          //     raw: options.file,
          //   });
          throw Error("No Support S3");
        }
        if (
          presignedInfo.code ||
          !presignedInfo.data ||
          !presignedInfo.data.uploadUrl ||
          !presignedInfo.data.url
        ) {
          // options.onError &&
          //   options.onError({
          //     msg: "getFilePresignedUrl Fai",
          //     originFileName: options.file.name,
          //     raw: options.file,
          //   });
          throw Error("getFilePresignedUrl Fail");
        }
        // 该层判断目的：采用axios是为了支持上传进度回调, 无需ProgressEvent的采用useFetch的实现;
        if (!!options.onProgress) {
          // 1.3 上传文件（不能使用 ElUpload 的 ajaxUpload 方法的原因：其使用的是 FormData 上传，Minio 不支持）
          // 又因为Nuxt的useFetch本身并不直接支持上传进度回调，因为它的设计目标是简化普通的 HTTP 请求，而不是处理文件上传或进度回调。
          // 所以引入axios来做此接口请求
          return axios
            .put(presignedInfo.data.uploadUrl, options.file, {
              headers: {
                "Content-Type": options.file.type,
              },
              proxy: false, // 明确禁用代理
              onUploadProgress: (progressEvent) => {
                options.onProgress && options.onProgress(progressEvent);
              },
              timeout: 1000 * 60 * 60, // 设置超时时间为 1 小时
            })
            .then(async () => {
              if (options.isNeddTriggerHandler && options.onSuccess) {
                return create(
                  presignedInfo.data,
                  fileName,
                  options.file,
                  options.onSuccess
                );
              } else {
                return create(presignedInfo.data, fileName, options.file);
              }
              // 1.4. 记录文件信息到后端（异步
              // 通知成功，数据格式保持与后端上传的返回结果一致
              // return { data: presignedInfo.data.url };
            })
            .catch((err) => {
              options.onError &&
                options.onError({
                  msg: "uploadUrl Fail:" + err,
                  originFileName: options.file.name,
                  raw: options.file,
                });
              throw Error("uploadUrl Fail:" + err);
            });
        } else {
          return useFetch(presignedInfo.data.uploadUrl, {
            method: "PUT",
            headers: {
              "Content-Type": options.file.type,
            },
            body: options.file,
            timeout: 1000 * 60 * 60, // 设置超时时间为 1 小时
          })
            .then(() => {
              // 1.4. 记录文件信息到后端（异步）
              // create(presignedInfo.data, fileName, options.file);
              // 通知成功，数据格式保持与后端上传的返回结果一致
              if (options.isNeddTriggerHandler && options.onSuccess) {
                return create(
                  presignedInfo.data,
                  fileName,
                  options.file,
                  options.onSuccess
                );
              } else {
                return create(presignedInfo.data, fileName, options.file);
              }
            })
            .catch((error) => {
              options.onError &&
                options.onError({
                  msg: "uploadUrl Fail:" + error,
                  originFileName: options.file.name,
                  raw: options.file,
                });
              throw Error("uploadUrl Fail:", error);
            });
        }
      } catch (err) {
        options.onError &&
          options.onError({
            msg: err,
            originFileName: options.file.name,
            raw: options.file,
          });
        throw Error(err);
      }
      // ;
      // 下面写了usePut的实现、以及用原生XMLHttpRequest封装的实现（基于后续可能不太好拓展，暂时选用axios）
      //   return usePut(presignedInfo.data.uploadUrl, options.file, {
      //     headers: {
      //       "Content-Type": options.file.type,
      //     },
      //     useRawUrl: true,
      //     proxy: false, // 明确禁用代理
      //     timeout: 1000 * 60 * 60, // 设置超时时间为 1 小时
      //   })
      //     .then(() => {
      //       // 1.4. 记录文件信息到后端（异步）
      //       // create(presignedInfo.data, fileName, options.file);
      //       // 通知成功，数据格式保持与后端上传的返回结果一致
      //       if (options.isNeddTriggerHandler && options.onSuccess) {
      //         return create(
      //           presignedInfo.data,
      //           fileName,
      //           options.file,
      //           options.onSuccess
      //         );
      //       } else {
      //         return create(presignedInfo.data, fileName, options.file);
      //       }
      //     })
      //     .catch((res) => {
      //       options.onError &&
      //         options.onError({
      //           msg: "uploadUrl Fail:" + res,
      //           originFileName: options.file.name,
      //           raw: options.file,
      //         });
      //       throw Error("uploadUrl Fail:", res);
      //     });
      // }
      // ;
      // return new Promise((resolve, reject) => {
      //   // 创建一个 XMLHttpRequest 对象
      //   const xhr = new XMLHttpRequest();

      //   // 设置上传接口
      //   xhr.open("PUT", presignedInfo.data.uploadUrl, true);

      //   // 设置上传进度回调函数
      //   xhr.upload.onprogress = function (event) {
      //     console.log("event:", event);
      //   };

      //   // 上传成功的回调
      //   xhr.onload = function () {
      //     if (xhr.status === 200) {
      //       createFile(presignedInfo.data, fileName, options.file);
      //       resolve(true);
      //       console.log("上传成功:", xhr.responseText);
      //     } else {
      //       console.error("上传失败:", xhr.statusText);
      //       reject();
      //     }
      //   };

      //   // 上传失败的回调
      //   xhr.onerror = function () {
      //     console.error("请求失败");
      //     reject();
      //   };

      //   // 发送请求
      //   xhr.send(options.file);
      // });
    } else {
      // 模式二：后端上传
      // 重写 el-upload httpRequest 文件上传成功会走成功的钩子，失败走失败的钩子
      return new Promise((resolve, reject) => {
        updateFile(options.file)
          .then((res) => {
            if (res.code === 0) {
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch((res) => {
            reject(res);
          });
      });
    }
  };

  const getCommonOptions = (
    file,
    onError?: Function,
    onProgress?: Function,
    onSuccess?: Function
  ) => {
    return {
      action: getUploadUrl(),
      data: {},
      file,
      filename: "file",
      headers: {},
      method: "post",
      onError,
      onProgress,
      onSuccess,
      withCredentials: false,
    };
  };

  return {
    uploadUrl,
    httpRequest,
    getCommonOptions,
  };
};

/**
 * 创建文件信息
 * @param vo 文件预签名信息
 * @param name 文件名称
 * @param file 文件
 */
async function create(
  vo: any,
  name: string,
  file: UploadRawFile,
  onSuccessCall?: Function
) {
  // 支持文件拓展属性回传
  const fileVo = {
    configId: vo.configId,
    url: vo.url,
    path: name,
    name: nameSliceHandler(file.name),
    type: file.type,
    size: file.size,
    fileExtension: file.fileExtension,
  };
  const result = await createFile(fileVo);
  onSuccessCall && onSuccessCall({ ...fileVo, fileId: result.data });
  return { ...fileVo, fileId: result.data };
}

const maxBytes = 9999;
/**
 * 生成文件名称（使用算法SHA256）
 * @param file 要上传的文件
 */
async function generateFileName(file: UploadRawFile) {
  // 读取文件内容
  const data = await file.arrayBuffer();

  // 防止data长度过长，CryptoJS无法读取
  const wordArray = CryptoJS.lib.WordArray.create(data.slice(0, maxBytes));

  // 将文件名加入哈希计算
  const fileNameHash = CryptoJS.SHA256(file.name).toString();

  // 计算SHA256
  const sha256 = CryptoJS.SHA256(wordArray).toString();

  // 使用时间戳确保唯一性
  const uniqueIdentifier = Date.now();

  // 拼接后缀
  const ext = file.name.substring(file.name.lastIndexOf("."));
  return `${sha256}-${uniqueIdentifier}-${fileNameHash}${ext}`;
}

/**
 * 上传类型
 */
enum UPLOAD_TYPE {
  // 客户端直接上传（只支持S3服务）
  CLIENT = "client",
  // 客户端发送到后端上传
  SERVER = "server",
}

export const IMAGE_UPLOAD_ACCEPT_TYPES = {
  JPG_PNG: ".jpeg, .jpg, .png",
  JPG_PNG_TYPES: ["jpeg", "jpg", "png"],
  JPG_PNG_WEBP: ".jpeg, .jpg, .png, .webp",
  JPG_PNG_WEBP_TYPES: ["jpeg", "jpg", "png", "webp"],
  JPG_PNG_WEBP_GIF: ".jpeg, .jpg, .png, .webp, .gif",
  JPG_PNG_WEBP_GIF_TYPES: ["jpeg", "jpg", "png", "webp", "gif"],
};

// 文件通用上传之前判断
export const beforeFileUpload: UploadProps["beforeUpload"] = (
  file: UploadRawFile,
  fileSize: number,
  fileType: string[],
  fileList?: UploadRawFile[],
  limit?: number
) => {
  const { $i18n } = useNuxtApp();
  if (!$i18n) return;
  const { t } = $i18n;
  if (!t) return;
  if (fileList && limit && fileList.length > limit) {
    useToast.error(t("upload.fileNumsLimit", { num: limit }));
    return false;
  }
  let fileExtension = "";
  if (file.name.lastIndexOf(".") > -1) {
    fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
  }
  const isImg = fileType.some((type: string) => {
    if (
      file.type.indexOf(type) > -1 ||
      file.type.indexOf(type.toUpperCase()) > -1
    )
      return true;
    return !!(
      fileExtension &&
      (fileExtension.indexOf(type) > -1 ||
        fileExtension.indexOf(type.toUpperCase()) > -1)
    );
  });
  if (!isImg) {
    useToast.error(t("upload.unsupported_file_format"));
    return false;
  }
  const isLimit = file.size < fileSize * 1024 * 1024;
  if (!isLimit) {
    useToast.error(
      t("upload.uploaded_file_exceeds_upper_limit", { value: `${fileSize}MB` })
    );
    return false;
  }
  return true;
};
